export default __webpack_public_path__ + "static/media-hero-bg-f039ca0802996212f195c9eded5014e6.jpg";